// removed by extract-text-webpack-plugin
module.exports = {"xsmall":"only screen and (min-width: 375px)","small":"only screen and (min-width: 481px)","medium":"only screen and (min-width: 768px)","large":"only screen and (min-width: 993px)","xlarge":"only screen and (min-width: 1201px)","retina":"(-webkit-min-device-pixel-ratio: 2)","portrait":"only screen and (orientation: portrait)","landscape":"only screen and (orientation: landscape)","syncsWrapper":"syncsWrapper-YgkNp","syncs":"syncs-3mlC1","content":"content-a8Fc4","callToAction":"callToAction-3kBVc","screen":"screen-1TvaI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/landing/syncs/_syncsLanding.css
// module id = 1229
// module chunks = 1